var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "filter filter--letters" },
    [
      _vm._l(_vm.items, function (item) {
        return [
          _c(
            "li",
            {
              staticClass: "filter--letters__item",
              class: item === _vm.value ? "active" : "",
            },
            [
              _c(
                "button",
                {
                  attrs: { role: "button", title: item },
                  on: {
                    click: function ($event) {
                      return _vm.onClickItem(item)
                    },
                  },
                },
                [_vm._v(_vm._s(item))]
              ),
            ]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }